module.exports = __webpack_public_path__ + "img/xmas.8f2eda84.png";